<div
	class="stepper"
	[class.stepper--selected]="showSelectedState && hasBeenTouched"
	data-test-id="amount-stepper-container"
>
	<div class="input-group">
		<div class="input-group-prepend">
			<button
				class="btn stepper__button"
				(click)="decrease()"
				[disabled]="!decreaseButtonIsEnabled || disabled"
				[class.stepper__button--disabled]="!decreaseButtonIsEnabled"
				data-test-id="amount-minus-button"
				aria-label="Minus-button"
			>
				<cramo-icon iconName="remove" />
			</button>
		</div>
		<input
			type="number"
			inputmode="numeric"
			cramoNumberOnly
			max="{{ max }}"
			min="{{ min }}"
			class="stepper__input form-control"
			[ngModel]="value"
			(ngModelChange)="onInputChange($event)"
			(keydown)="stripDecimals($event)"
			[class.is-invalid]="error"
			[class.stepper__input--selected]="showSelectedState && hasBeenTouched"
			[disabled]="disabled"
			aria-label="stepper"
		/>
		<div class="input-group-append">
			<button
				class="btn stepper__button"
				(click)="increase()"
				[disabled]="!increaseButtonIsEnabled || disabled"
				[class.stepper__button--disabled]="!increaseButtonIsEnabled"
				data-test-id="amount-plus-button"
				aria-label="Plus-button"
			>
				<cramo-icon iconName="add" />
			</button>
		</div>
	</div>
	@if (error) {
		<div class="invalid-feedback" data-test-id="amount-stepper-error">
			{{ appData().cart.errorQuantityLink }}
		</div>
	}
</div>
